import {
    IAdminFlatAnalyticsResultDto,
    IAdminActiveCompanyInfo,
    IAdminConversion,
    IAdminConversionDto,
    IAdminPanelAnalyticsUseCase,
} from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class AdminPanelAnalyticsUseCase implements IAdminPanelAnalyticsUseCase {
    public async getFlatAnalytics(): Promise<IAdminFlatAnalyticsResultDto> {
        try {
            const response = await Api.get<IAdminFlatAnalyticsResultDto>("/admin/analytics/flat");
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async getActiveCompanies(): Promise<IAdminActiveCompanyInfo[]> {
        try {
            const response = await Api.get<IAdminActiveCompanyInfo[]>("/admin/analytics/active-companies");
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async getConversion(dto: IAdminConversionDto): Promise<IAdminConversion[]> {
        try {
            const params = dto;
            const response = await Api.get<IAdminConversion[]>("/admin/analytics/conversion", { params });
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
